// Vue
import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
// Template
import template from './template.vue'
// Components
import {Modal} from '../modal/Modal'
import {Icon} from '../icon/Icon'

declare var process : {
    env: {
        NODE_ENV: string
    }
}

@Component({
    components: {
        Modal,
        Icon
    },
    mixins: [
        template,
    ]
})
export class ModalIframe extends Vue {

    private startLoadingIframe: boolean = false

    private loadingCompleted: boolean = false

    @Prop()
    public iframeUrl!: string

    @Prop({default: false})
    public visible!: boolean

    @Prop({default: true})
    public closeable!: boolean

    @Prop()
    public title?: string

    @Prop({default: 'md'})
    public size!: string

    private onUpdateVisible(event) {
        this.$emit('update:visible', event)
    }
    private onClose(event) {
        this.$emit('close', event)
    }

    @Watch('visible')
    public onVisibleChange() {
        if (this.visible) {
            this.startLoadingIframe = true
        }
    }

    private onIFrameLoaded(e: any) {
        this.loadingCompleted = true
    }

}